import { Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/config/app.config';
import { CtaSection, FeaturesSection, Footer, HeroSection, PricingSection } from '@/presentation/components/landing';
import { useAuthStore } from '@/stores/use-auth-store';

export function LandingPage() {
    const { isAuthenticated } = useAuthStore();

    if (isAuthenticated) {
        return <Navigate to={ROUTES.dashboard} replace />;
    }

    return (
        <Box>
            <HeroSection />
            <FeaturesSection />
            <PricingSection />
            <CtaSection />
            <Footer />
        </Box>
    );
}

export default LandingPage;
